import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["emailTemplate", "locale"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from 'react-query';
import api from 'utils/api';
import useUserLocale from 'hooks/useUserLocale';
import emailTemplateKeys from './queryKeys';
export var useFetchEmailTemplateQuery = function useFetchEmailTemplateQuery(_ref) {
  var emailTemplate = _ref.emailTemplate,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? null : _ref$locale,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  var _useUserLocale = useUserLocale(),
    defaultLocale = _useUserLocale.locale;
  var resolvedLocale = locale === null ? defaultLocale : locale || defaultLocale;
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api('get', "/api/emailTemplates/".concat(emailTemplate, "/").concat(resolvedLocale), null);
          case 2:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = emailTemplateKeys.singleEmailTemplate(emailTemplate, resolvedLocale);
  var _useQuery = useQuery(queryKey, queryFn, _objectSpread({
      staleTime: Infinity
    }, queryOptions)),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
};
export default useFetchEmailTemplateQuery;